// The email-measurement change to the Privacy Policy (#2493). The wording is
// the founder-approved third draft (2026-09-29). It was first planned with a
// 30-day notice; on 2026-10-06 the founder waived the wait ("We can start
// click tracking on emails now.. dont wait until Oct 30th"), so the change is
// effective the day it was published.
//
// One definition for every surface that states the date: the Privacy Policy
// and the Student Data Principles. The senders refuse to track before the
// same date (TRACKING_STARTS_AT in cloud_functions/marketing_agent/
// desk_clients.py), the browser's email-landing hold imports it
// (services/attribution.js), and profile_manager_v2's first_touch.py keeps a
// copy; tests/cloud_functions/marketing_agent/test_email_tracking.py pins all
// of them together.

// October 16: session replay for every visitor (#4475, founder directive).
// Comments on a shared link (#4997): the Privacy paragraph on notes. This PR
// merges right after the go-live click; set this to that day when merging.
// October 22: the sign-in providers, Apple and Facebook (#5154).
// October 23: what a connected assistant can read and change, and ChatGPT's
// training setting (#5259, the privacy pass for the directory listings).
export const POLICY_UPDATED_LABEL = 'October 23, 2026';

export const EMAIL_MEASUREMENT_STARTS = '2026-10-06';
export const EMAIL_MEASUREMENT_STARTS_LABEL = 'October 6, 2026';

// The notice text, shared by the Privacy Policy and the Student Data
// Principles: the founder-approved wording (2026-09-29, third draft),
// verbatim except the framing, which now says the change is in effect. Each
// page renders the closing "The details are in Section 8." itself, with its
// own link.
export const NOTICE_TITLE = `Notice of a change to our Privacy Policy, effective ${EMAIL_MEASUREMENT_STARTS_LABEL}`;
export const NOTICE_BODY = [
    'We connect what you do in the product to your account, to understand how '
        + 'the product is used and to follow up with customers.',
    'Our policy did not say this clearly, and now it does.',
    `From ${EMAIL_MEASUREMENT_STARTS_LABEL} we do two new things.`,
    'We use that activity to decide which reminders to send you.',
    'And when we send you product news or a reminder, we record, '
        + 'against your email address, whether it was opened and which link was clicked.',
    'We do both so we can send you reminders you can use and stop sending '
        + 'email that people do not read.',
    'None of this is sold or shared with advertisers, and what you type into '
        + 'a box is masked in any recording.',
    'To stop the emails, use the unsubscribe link in any of them.',
].join(' ');
